import React from 'react'
import { Link } from 'wouter'
import { ArrowLeft } from 'lucide-react'

interface BackButtonProps {
  href: string
  label?: string
  className?: string
}

export function BackButton({ href, label = 'Back', className = '' }: BackButtonProps) {
  return (
    <Link href={href} className={`inline-flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground transition-colors ${className}`}>
      <ArrowLeft className="w-4 h-4" />
      <span>{label}</span>
    </Link>
  )
}

// Helper function to determine appropriate back navigation
export function getBackNavigationForPath(pathname: string): { href: string; label: string } | null {
  // Deep dive pages should go back to dashboard
  const deepDivePages = ['revenue-detail', 'units-detail', 'skus-detail']
  const currentPage = pathname.split('/').filter(Boolean)[0]
  
  if (deepDivePages.includes(currentPage)) {
    return { href: '/dashboard', label: 'Back to Dashboard' }
  }

  // For most pages, breadcrumbs are sufficient
  return null
}
